import { PropInfo } from '../components/sections/TextSection'
export const borderProps: PropInfo[] = [
  {
    name:"Border Color",
    inputType: 'color',
    binding:'style.borderColor',
    value: 'black',
    label: 'Border Color',
  },
  {
    name:"Border Type",
    label: 'Border Type',
    inputType: 'dropdown',
    options:[
      { label: 'Solid', value: 'solid' },
      { label: 'Dotted', value: 'dotted' },
      { label: 'Dashed', value: 'dashed' },
      { label: 'Double', value: 'double' },
      { label: 'Groove', value: 'groove' },
      { label: 'Ridge', value: 'ridge' },
      { label: 'Inset', value: 'inset' },
      { label: 'Outset', value: 'outset' },
    ],
    binding:'style.borderStyle',
    value: 'solid',
  },
  {
    name: 'Border Radius',
    inputType: 'number',
    binding: 'style.borderRadius',
    value: '0px',
    label: 'Border Radius',
  },
  {
    name:"Border Width",
    inputType: 'number',
    binding:'style.borderWidth',
    value: '0px',
    label: 'Border Width',
  }
]

export const commonProps: PropInfo[] = [
  {
    name: 'Show Scrollbar',
    inputType: 'dropdown',
    binding: 'style.overflow',
    options: [
      { label: 'Show', value: 'auto' },
      { label: 'hide', value: 'hidden' },
    ],
    value: 'hidden',
    label: 'Scroll Visible',
  },
  {
    name:"Audio",
    inputType: 'audio',
    binding: 'audio',
    value: '',
    label: 'Audio',
  },
  
  {
    name: 'padding',
    inputType: 'number',
    binding: 'style.padding',
    value: '0',
    hidden: true,
    label: 'Padding',
  },
  
  {
    name: "Rotation",
    inputType: 'number',
    binding: 'style.transform',
    value: 0,
    label: 'Rotation',
  }
]

export const fontProps: PropInfo[] = [
  {
    name: "background",
    inputType: 'gradientcolor',
    binding: 'style.background',
    value: '',
    label: 'Background',
  },
  {
    name: 'color',
    inputType: 'color',
    binding: 'style.color',
    value: '#778a8f',
    label: 'Color',
  },
  {
    name: 'fontSize',
    binding: 'style.fontSize',
    inputType: 'number',
    value: '12px',
    label: 'Font Size',
  },
  {
    name: 'fontFamily',
    inputType: 'dropdown',
    options: [      
      { "label": "Primer Print", "value": "Primer Print" },
      { "label": "Avenir Next LT Pro", "value": "Avenir Next LT Pro" },
      { "label": "Cooper Black", "value": "Cooper Black" },
      { "label": "Teachers Pet", "value": "Teachers Pet" },
      { "label": "Papyrus", "value": "Papyrus" },
      { "label": "monospace", "value": "monospace" },
      { "label": "Arial", "value": "Arial" },
      { "label": "Times New Roman", "value": "Times New Roman" },
      { "label": "Courier New", "value": "Courier New" },
      { "label": "Georgia", "value": "Georgia" },
      { "label": "Verdana", "value": "Verdana" },
      { "label": "Trebuchet MS", "value": "Trebuchet MS" },
      { "label": "Comic Sans MS", "value": "Comic Sans MS" },
      { "label": "Impact", "value": "Impact" },
      { "label": "Garamond", "value": "Garamond" },
      { "label": "Palatino Linotype", "value": "Palatino Linotype" },
      { "label": "Tahoma", "value": "Tahoma" },
      { "label": "Parchment", "value": "Parchment" },
      { "label": "Poor Richard", "value": "Poor Richard" },
      { "label": "Black Ladder", "value": "Black Ladder" },
      { "label": "Ravie", "value": "Ravie" },
      { "label": "Bauhaus", "value": "Bauhaus" },
      { "label": "Brush Script MT", "value": "Brush Script MT" }
    ],
    
    binding: 'style.fontFamily',
    value: 'Primer Print',
    label: 'Font Family',
  },
]

export const ailmentProps: PropInfo[] = [
  {
    name: 'Horizontal Alignment',
    inputType: 'dropdown',
    options: [
      { label: 'Left', value: 'left' },
      { label: 'Right', value: 'right' },
      { label: 'Center', value: 'center' },
    ],
    binding: 'style.textAlign',
    value: 'center',
    label: 'Horizontal Alignment',
  },
  {
    name: 'Verticle Alignment',
    inputType: 'dropdown',
    options: [
      { label: 'Top', value: 'flex-start' },
      { label: 'bottom', value: 'flex-end' },
      { label: 'Center', value: 'center' },
    ],
    binding: 'style.alignContent',
    value: 'center',
    label: 'Horizontal Alignment',
  },
]